<template>

    <div>
        
        <el-form :inline="true" :model="query" class="query-form">
            <el-form-item>
                <el-button type="" @click.native="addNewTag">添加</el-button>
            </el-form-item>

            <el-form-item>
                <el-input v-model="query.name" placeholder="标签名称" ></el-input>
            </el-form-item>

            <el-form-item>
                <el-button-group>
                    <el-button type="primary" icon="el-icon-search" @click.native="onSubmit(1)">查询</el-button>
                    <el-button type="primary"  icon="el-icon-refresh" @click="onSubmit(2)">重置</el-button>
                </el-button-group>
            </el-form-item>
            
        </el-form>

        <el-table
            tooltip-effect="dark"
            v-loading="loading"
            ref="multipleTable"
            :data="data"
            style="width: 100%;"
            :header-cell-style="{background:'#F4F4F5',color:'#606266'}"
        >
            <el-table-column label="编号" prop="cate_id"> </el-table-column>
            <el-table-column label="标签名称" prop="cate_name"> </el-table-column>
            <el-table-column label="文章数量" prop="page_count"> </el-table-column>
            <el-table-column label="添加时间" prop="create_time_str"></el-table-column>
            <!-- <el-table-column label="资助状态" prop="view_num"> </el-table-column> -->
            <el-table-column
                label="操作"
                fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click.native="handleForm(scope.row, scope.$index)">查看</el-button>
                    <!-- <el-button type="text" size="small" @click.native="handleDel(scope.$index, scope.row.apply_id)">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="pagination-container"
            style="height:50px;"
            background
            :page-size="query.limit"            
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :total="total"
            :current-page.sync="query.page">
        </el-pagination>

        <!-- 新增/修改标签弹窗 -->
        <el-dialog
            :title="editTitle"
            :visible.sync="formVisible"
            :before-close="hideForm"
            width="35%"
            >
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="标签名称" prop="cate_name">
                    <el-input v-model.trim="formData.cate_name" auto-complete="off" style="width:50%;"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import { BASE_URL } from "../../config/app";
import { tagIndexList, tagEdit} from "../../api/tagManager/index";
export default {
    data() {
        return {
            // toExportUrl:BASE_URL+'admin/apply/apply/toExport',
            loading: true,
            total: 0,
            currentPage: 1,
            query: {
                page: 1,
                name: "",
                token: "",
                limit: 10,
            },
            data: [],

            // 弹窗相关
            formData: {},
            formRules: {
                cate_name: [
                    { required: true, message: "请输入标签名称", trigger: "blur" }
                ],
            },
            formLoading: false,
            formVisible: false,
            editTitle: "编辑标签",
        };
    },
    methods: {
        backHistory(){
            this.$router.go(-1);//返回上一层
        },
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            return true;
        },
        formSubmit() {
            // 新增/保存
            this.$refs["dataForm"].validate( ( valid) => {
                if( valid){
                    // this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    console.log( "form data", data);

                    tagEdit( data)
                        .then( ( res) => {

                            if( res.code == 200){
                                this.$succMsg( "保存成功");
                                this.hideForm();
                                this.getData();
                            }
                        })
                        .catch( () => {
                            this.$errMsg( "保存失败")
                        });
                }
            });
        },
        addNewTag(){
            // 添加新标签
            this.editTitle = "新增标签";
            this.formData = {
                cate_id: "",
                cate_name: ""
            };
            this.formVisible = true;
            // this.$message.error( "保存失败");
        },
        getData() {
            this.loading = true;
            var obj = this.query;

            tagIndexList( obj).then(response => {
                this.data = response.data.data || [];
                this.loading = false;
                this.total = response.data.total;
            }).catch(() => {
                this.loading = false;
                this.data = [];
                this.total = 0;
            });
        },
        handleCurrentChange(val) {
            this.query.page = val;
            sessionStorage.setItem( "currentPage_findList", val);
            // scrollTo(0, 800);
            this.getData();
        },
        onSubmit(type) {
            // this.query.page = 1;
            if (type == 1) {
                this.getData();
            }
            if (type == 2) {
                this.currentPage = 1;
                this.query = {
                    page: 1,
                    name: "",
                    token: "",
                    limit: 10,
                };
                this.getData();
            }
        },
        handleForm( row, index) {
            this.editTitle = "编辑标签";
            this.formData = row;
            this.formVisible = true;
        },
    },
    filters: {
    },
    mounted() {},
    created() {
        sessionStorage.setItem( "currentPage_advertList", 1);
        sessionStorage.setItem( "currentPage_findVideoList", 1);
        sessionStorage.setItem( "currentPage_findList", 1);
        sessionStorage.setItem( "currentPage_messageList", 1);
        sessionStorage.setItem( "currentPage_normalUsersAdmin", 1);
        sessionStorage.setItem( "currentPage_userList", 1);
        sessionStorage.setItem( "currentPage_editorList", 1);
        this.query.page = 1;
        // this.query.page = Number(sessionStorage.getItem("currentPage_findList")) || 1;
        this.getData();
    }
};
</script>
<style type="text/scss" lang="scss">
</style>
<style>
 .el-form-item__label{
     margin-top: 5px;
 }
</style>
